import { render, staticRenderFns } from "./HistoricoLicencias.vue?vue&type=template&id=18a67aea"
import script from "./HistoricoLicencias.vue?vue&type=script&lang=js"
export * from "./HistoricoLicencias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports